import {
  BellIcon,
  CalendarIcon,
  CircleDollarSignIcon,
  FilePenIcon,
  HandCoinsIcon,
  KeyRoundIcon,
  ListOrderedIcon,
  RefreshCwIcon,
  RouteIcon,
  ShieldCheckIcon,
  TrendingUpIcon,
  UsersIcon,
  WebhookIcon,
} from "lucide-react"

import type { PermissionsRolesEnum } from "@/enums"

import FRONTEND_ROUTES from "./front-end-routes"
import PERMISSION_ROLES from "./permission-roles"
interface SidebarSubLink {
  href: string
  tooltip: string
  label: string
  mainPath: string
}
export interface SidebarLink {
  href: string
  icon: React.ElementType
  tooltip: string
  label: string
  mainPath: string
  permissionRoles: readonly PermissionsRolesEnum[]
  // Exclusivo staff Pay2B (@pay2b.io).
  requireSuperAdmin: boolean
  // Admin do merchant (visível com isAdmin || isSuperAdmin).
  requireAdmin: boolean
  subLinks?: SidebarSubLink[]
}
const SIDEBAR_LINKS: SidebarLink[] = [
  {
    href: FRONTEND_ROUTES.DASHBOARD.href,
    icon: TrendingUpIcon,
    tooltip: "sidebar.dashboard",
    label: "sidebar.dashboard",
    mainPath: FRONTEND_ROUTES.DASHBOARD.href,
    permissionRoles: PERMISSION_ROLES.DASHBOARD,
    requireSuperAdmin: false,
    requireAdmin: false,
  },
  {
    href: FRONTEND_ROUTES.SCHEDULE.href,
    icon: CalendarIcon,
    tooltip: "sidebar.schedule",
    label: "sidebar.schedule",
    mainPath: FRONTEND_ROUTES.SCHEDULE.href,
    permissionRoles: PERMISSION_ROLES.SCHEDULE,
    requireSuperAdmin: false,
    requireAdmin: false,
  },
  {
    href: FRONTEND_ROUTES.SALES.href,
    icon: CircleDollarSignIcon,
    tooltip: "sidebar.sales",
    label: "sidebar.sales",
    mainPath: FRONTEND_ROUTES.SALES.href,
    permissionRoles: PERMISSION_ROLES.SALES,
    requireSuperAdmin: false,
    requireAdmin: false,
  },
  {
    href: FRONTEND_ROUTES.ORDERS.href,
    icon: ListOrderedIcon,
    tooltip: "sidebar.orders",
    label: "sidebar.orders",
    mainPath: FRONTEND_ROUTES.ORDERS.href,
    permissionRoles: PERMISSION_ROLES.ORDERS,
    requireSuperAdmin: false,
    requireAdmin: false,
  },
  {
    href: FRONTEND_ROUTES.SUBSCRIPTIONS.href,
    icon: FilePenIcon,
    tooltip: "sidebar.subscriptions",
    label: "sidebar.subscriptions",
    mainPath: FRONTEND_ROUTES.SUBSCRIPTIONS.href,
    permissionRoles: PERMISSION_ROLES.SUBSCRIPTIONS,
    requireSuperAdmin: false,
    requireAdmin: false,
  },
  {
    href: FRONTEND_ROUTES.CUSTOMERS.href,
    icon: UsersIcon,
    tooltip: "sidebar.customers",
    label: "sidebar.customers",
    mainPath: FRONTEND_ROUTES.CUSTOMERS.href,
    permissionRoles: PERMISSION_ROLES.CUSTOMERS,
    requireSuperAdmin: false,
    requireAdmin: false,
  },
  {
    href: FRONTEND_ROUTES.ACCESS_MANAGEMENT.href,
    icon: KeyRoundIcon,
    tooltip: "sidebar.accessManagement",
    label: "sidebar.accessManagement",
    mainPath: FRONTEND_ROUTES.ACCESS_MANAGEMENT.href,
    permissionRoles: PERMISSION_ROLES.ACCESS_MANAGEMENT,
    requireSuperAdmin: false,
    requireAdmin: true,
  },
  {
    href: FRONTEND_ROUTES.DEFAULTERS.href,
    icon: HandCoinsIcon,
    tooltip: "sidebar.defaulters",
    label: "sidebar.defaulters",
    mainPath: FRONTEND_ROUTES.DEFAULTERS.href,
    permissionRoles: PERMISSION_ROLES.DEFAULTERS,
    requireSuperAdmin: false,
    requireAdmin: false,
  },
  {
    href: FRONTEND_ROUTES.WEBHOOKS.href,
    icon: WebhookIcon,
    label: "sidebar.webhooks",
    mainPath: FRONTEND_ROUTES.WEBHOOKS.href,
    permissionRoles: PERMISSION_ROLES.WEBHOOKS,
    tooltip: "sidebar.webhooks",
    requireSuperAdmin: false,
    requireAdmin: false,
  },
  {
    href: FRONTEND_ROUTES.REPIC_CENTER.href,
    icon: RefreshCwIcon,
    tooltip: "sidebar.repicCenter",
    label: "sidebar.repicCenter",
    mainPath: FRONTEND_ROUTES.REPIC_CENTER.href,
    permissionRoles: PERMISSION_ROLES.REPIC_CENTER,
    requireSuperAdmin: false,
    requireAdmin: true,
  },
  {
    href: FRONTEND_ROUTES.SMART_ROUTING.href,
    icon: RouteIcon,
    tooltip: "sidebar.smartRouting",
    label: "sidebar.smartRouting",
    mainPath: FRONTEND_ROUTES.SMART_ROUTING.href,
    permissionRoles: PERMISSION_ROLES.SMART_ROUTING,
    requireSuperAdmin: false,
    requireAdmin: true,
    subLinks: [
      {
        href: FRONTEND_ROUTES.SMART_ROUTING_DASHBOARD.href,
        tooltip: "sidebar.dashboard",
        label: "sidebar.dashboard",
        mainPath: "/dashboard",
      },
      {
        href: FRONTEND_ROUTES.SMART_ROUTING_CONFIGURATIONS
          .href,
        tooltip: "sidebar.configurations",
        label: "sidebar.configurations",
        mainPath: "/configurations",
      },
    ],
  },
  {
    // O dashboard (/notification-center) está oculto do menu: os dados dele não
    // saem direto da tabela de notificações. Volta quando existir uma base
    // agregada (OpenSearch/Redis) alimentada pelo fluxo do notification.
    href: FRONTEND_ROUTES.NOTIFICATION_CENTER_SEARCH.href,
    icon: BellIcon,
    tooltip: "sidebar.notifications",
    label: "sidebar.notifications",
    // mainPath continua na raiz para o menu seguir destacado em todas as abas.
    mainPath: FRONTEND_ROUTES.NOTIFICATION_CENTER.href,
    permissionRoles: PERMISSION_ROLES.NOTIFICATION_CENTER,
    requireSuperAdmin: false,
    requireAdmin: true,
    subLinks: [
      {
        href: FRONTEND_ROUTES.NOTIFICATION_CENTER_SEARCH
          .href,
        tooltip: "pages.notificationCenter.search",
        label: "pages.notificationCenter.search",
        mainPath: "/search",
      },
      {
        href: FRONTEND_ROUTES
          .NOTIFICATION_CENTER_CONFIGURATIONS.href,
        tooltip: "pages.notificationCenter.configurations",
        label: "pages.notificationCenter.configurations",
        mainPath: "/configurations",
      },
      {
        href: FRONTEND_ROUTES.NOTIFICATION_CENTER_TEMPLATES
          .href,
        tooltip: "pages.notificationCenter.templates",
        label: "pages.notificationCenter.templates",
        mainPath: "/templates",
      },
    ],
  },
  {
    // O grupo abre no PRIMEIRO subitem: com o reprocesso aqui, clicar em
    // "Administração" caía numa tela de operação, não no começo do cadastro.
    href: FRONTEND_ROUTES.ADMIN_MERCHANT.href,
    icon: ShieldCheckIcon,
    tooltip: "sidebar.administration",
    label: "sidebar.administration",
    mainPath: "/admin",
    permissionRoles: PERMISSION_ROLES.ADMIN_REPROCESS,
    requireSuperAdmin: true,
    requireAdmin: false,
    subLinks: [
      // Ordem do fluxo real de cadastro: o merchant existe primeiro, os white
      // labels penduram nele, as credenciais são do merchant e o reprocesso é
      // operação do dia a dia — não cadastro.
      {
        href: FRONTEND_ROUTES.ADMIN_MERCHANT.href,
        tooltip: "sidebar.merchant",
        label: "sidebar.merchant",
        mainPath: "/merchant",
      },
      {
        href: FRONTEND_ROUTES.ADMIN_WHITE_LABELS.href,
        tooltip: "sidebar.whiteLabels",
        label: "sidebar.whiteLabels",
        mainPath: "/white-labels",
      },
      {
        href: FRONTEND_ROUTES.ADMIN_MERCHANT_PROCESSORS
          .href,
        tooltip: "sidebar.merchantProcessors",
        label: "sidebar.merchantProcessors",
        mainPath: "/processors",
      },
      // Vem DEPOIS de Processadores porque é essa a ordem do domínio: a
      // credencial existe primeiro, e o meio de pagamento aponta para ela.
      //
      // A aba de métodos do white label continua sendo o caminho por white
      // label; esta é a visão de todos, que é onde se compara e se corrige em
      // lote — e a única forma de chegar nela sem já saber qual white label.
      {
        href: FRONTEND_ROUTES.ADMIN_PROCESSOR_CONFIG.href,
        tooltip: "sidebar.paymentMethods",
        label: "sidebar.paymentMethods",
        mainPath: "/processor-config",
      },
      {
        href: FRONTEND_ROUTES.ADMIN_REPROCESS.href,
        tooltip: "sidebar.reprocessPayments",
        label: "sidebar.reprocessPayments",
        mainPath: "/reprocess",
      },
      {
        href: FRONTEND_ROUTES.ADMIN_WEBHOOK_INBOX.href,
        tooltip: "sidebar.webhookInbox",
        label: "sidebar.webhookInbox",
        mainPath: "/webhook-inbox",
      },
    ],
  },
]
export default SIDEBAR_LINKS
